import { modalRoutes as r, routes as t } from "./routes.js";
import { PathId as p, saveActiveWorkspace as R } from "./routes.js";
import { createRouter as e, createMemoryHistory as o, createWebHashHistory as s, createWebHistory as a } from "vue-router";
const y = () => e({
  history: a(),
  routes: t
}), m = () => e({
  history: s(),
  routes: t
}), u = () => e({
  history: o(),
  routes: r
});
export {
  p as PathId,
  u as createModalRouter,
  m as createWebHashRouter,
  y as createWebHistoryRouter,
  R as saveActiveWorkspace
};
